module.exports = __webpack_public_path__ + "static/media/Link.97b0630b.svg";